import {
  COMPANY_ADMIN_SET_USERS,
  COMPANY_ADMIN_EDIT_POST,
  EDIT_BRAND,
  COMPANY_ADMIN_REMOVE_POST,
  COMPANY_ADMIN_REMOVE_USER_FROM_COMPANY,
  COMPANY_ADMIN_REMOVE_USER_FROM_BRAND,
  COMPANY_ADMIN_ADD_USER_TO_BRAND,
  COMPANY_ADMIN_SET_NEW_COMPANY_ADMIN,
  
} from '../constants/action-types/company-admin';

const initialState = {
  users: null,
  brands: null,
  company: null,
};

const companyAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_ADMIN_SET_USERS:
      return { ...state, users: action.payload };

    case 'COMPANY_ADMIN_SET_BRANDS':
      return { ...state, brands: action.payload };

    case 'COMPANY_ADMIN_SET_COMPANY':
      return { ...state, company: action.payload };

    case COMPANY_ADMIN_EDIT_POST:
      const { newTimeline, oldTimeline } = action.payload;

      const neededBrand = state.brands.find(brandItem => {
        return brandItem._id === oldTimeline.brand_id;
      });

      
      const neededBrandIndex = state.brands.findIndex(brandItem => {
        return brandItem._id === oldTimeline.brand_id;
      });

      const postToEdit = neededBrand.posts.findIndex(
        post => oldTimeline._id === post._id,
      );

      const newPosts = [
        ...neededBrand.posts.slice(0, postToEdit),
        newTimeline,
        ...neededBrand.posts.slice(postToEdit + 1),
      ];

      const newBrands = [
        ...state.brands.slice(0, neededBrandIndex),
        { ...neededBrand, posts: newPosts },
        ...state.brands.slice(neededBrandIndex + 1),
      ];

      return {
        ...state,
        brands: newBrands,
      };

      case EDIT_BRAND:
        console.log({state})
      const  newBrand  = action.payload;
      

      const neededBrandToEdit = state.brands.find(brandItem => {
        return brandItem._id === newBrand._id;
      });

      
      const neededBrandIndexToEdit = state.brands.findIndex(brandItem => {
        return brandItem._id === newBrand._id;
      });

     

     

      const newBrandsAfterUpdate = [
        ...state.brands.slice(0, neededBrandIndexToEdit),
        { ...neededBrandToEdit, img: newBrand.img},
        ...state.brands.slice(neededBrandIndexToEdit + 1)
      ];

      return {
        ...state,
        brands: [...newBrandsAfterUpdate]
      };

    case COMPANY_ADMIN_REMOVE_POST: {
      // Defensive against missing slices: super-admin contexts that
      // dispatch the post-delete signal don't always hydrate
      // companyAdmin.brands (or hydrate it with brands that have no
      // `posts` array). Any of `state.brands`, `brand.posts`, or the
      // matching brand being undefined used to throw a TypeError in
      // the reducer — uncaught, surfaced by the DeleteModal HOC's
      // catch() as "Something went wrong with deleting post" even
      // when the server returned 200. No-op if the post isn't found
      // in this slice — the main state.post.posts case already
      // handles the UI removal.
      const brands = Array.isArray(state.brands) ? state.brands : [];
      const neededBrandIndex = brands.findIndex((b) =>
        Array.isArray(b && b.posts) &&
        b.posts.some((p) => p && p._id === action.payload)
      );
      if (neededBrandIndex < 0) return state;
      const neededBrand = brands[neededBrandIndex];
      const newPosts = neededBrand.posts.filter((p) => p && p._id !== action.payload);
      const newBrands = [
        ...brands.slice(0, neededBrandIndex),
        { ...neededBrand, posts: newPosts },
        ...brands.slice(neededBrandIndex + 1),
      ];

      return {
        ...state,
        brands: newBrands,
      };
    }

    case COMPANY_ADMIN_REMOVE_USER_FROM_COMPANY:
      const userToDeleteIndex = state.users.findIndex(
        user => user._id === action.payload,
      );

      return {
        ...state,
        users: [
          ...state.users.slice(0, userToDeleteIndex),
          ...state.users.slice(userToDeleteIndex + 1),
        ],
      };

    case COMPANY_ADMIN_REMOVE_USER_FROM_BRAND: {
      const { user, brand } = action.payload;

      const neededBrand = state.brands.find(
        brandItem => brandItem._id === brand,
      );

      const neededBrandIndex = state.brands.findIndex(
        brandItem => brandItem._id === brand,
      );

      const neededUserIdIndex = neededBrand.users.findIndex(
        userId => userId === user,
      );

      const neededBrandWithoutUser = {
        ...neededBrand,
        users: [
          ...neededBrand.users.slice(0, neededUserIdIndex),
          ...neededBrand.users.slice(neededUserIdIndex + 1),
        ],
      };

      const newBrands = [
        ...state.brands.slice(0, neededBrandIndex),
        neededBrandWithoutUser,
        ...state.brands.slice(neededBrandIndex + 1),
      ];

      return {
        ...state,
        brands: newBrands,
      };
    }

    case COMPANY_ADMIN_ADD_USER_TO_BRAND: {
      const { user, brand } = action.payload;

      const neededBrand = state.brands.find(
        brandItem => brandItem._id === brand,
      );

      const neededBrandIndex = state.brands.findIndex(
        brandItem => brandItem._id === brand,
      );

      const neededBrandWithUser = {
        ...neededBrand,
        users: [...neededBrand.users, user],
      };

      const newBrands = [
        ...state.brands.slice(0, neededBrandIndex),
        neededBrandWithUser,
        ...state.brands.slice(neededBrandIndex + 1),
      ];

      return {
        ...state,
        brands: newBrands,
      };
    }

    case COMPANY_ADMIN_SET_NEW_COMPANY_ADMIN: {
      const oldUserAdmin = state.users.find(user => user.companyAdmin === true);

      if (oldUserAdmin._id === action.payload._id) {
        return state;
      } else {
        const oldUserAdminIndex = state.users.findIndex(
          user => user.companyAdmin === true,
        );

        const newUserWithoutAdmin = { ...oldUserAdmin, companyAdmin: false };

        const oldUserWithoutAdminIndex = state.users.findIndex(
          user => user._id === action.payload._id,
        );

        if (oldUserAdminIndex > oldUserWithoutAdminIndex) {
          const newUsers = [
            ...state.users.slice(0, oldUserWithoutAdminIndex),
            action.payload,
            ...state.users.slice(
              oldUserWithoutAdminIndex + 1,
              oldUserAdminIndex,
            ),
            newUserWithoutAdmin,
            ...state.users.slice(oldUserAdminIndex + 1),
          ];

          return {
            ...state,
            users: newUsers,
          };
        } else {
          const newUsers = [
            ...state.users.slice(0, oldUserAdminIndex),
            newUserWithoutAdmin,
            ...state.users.slice(
              oldUserAdminIndex + 1,
              oldUserWithoutAdminIndex,
            ),
            action.payload,
            ...state.users.slice(oldUserWithoutAdminIndex + 1),
          ];

          return {
            ...state,
            users: newUsers,
          };
        }
      }
    }

    default:
      return state;
  }
};

export default companyAdminReducer;
